import { useLayoutEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import QuaterList from '../../quaterwise-view/QuaterList';
import LibrarySections from '../library-section/LibrarySections';
import ProgramSection from '../program-section/ProgramSection';
import MyStance from '../stance-section/MyStance';
const Home = () => {

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<ProgramSection />} />
          <Route path="/quater-list" element={<QuaterList />} />
          <Route path="/library/*" element={<LibrarySections />} />
          <Route path="/my-stance" element={<MyStance />} />
        </Routes>
      </div>
  );
};
export default Home;
